<template>
  <v-container class="pt-10 pb-5 px-5">
    <v-row>
      <v-col cols="3"> <AuthorSummaries /> </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AuthorSummaries from "./Includes/AuthorSummaries.vue";
export default {
  components: {
    AuthorSummaries,
  },
};
</script>

<style lang="scss">
.stats-card {
  p {
    small {
      color: #999898;
    }

    small:last-child {
      text-transform: uppercase;
    }
  }
}

.stats-details {
  h3,
  h4 {
    display: flex;
    flex-wrap: wrap;
    margin: 0.75em 0;

    // align-content: center;
    // justify-content: center;

    small {
      margin-left: 0.5em;
      display: inline-block;
    }
  }

  h3 {
    margin-top: 1em;
    font-size: 4em;
    flex-direction: column;
    small {
      font-size: 1rem;
      margin-top: 1em;
    }
  }

  h4 {
    font-size: 1.7em;
    small {
      display: inline-block;
      font-size: 0.85rem;
      margin-left: 0.7rem;
    }
  }
}

.stat {
  h3 {
    small {
      margin-left: 8px;
      display: inline-block;
    }
  }
  h3 + h3 {
    margin-top: 0.75rem;
  }
}

.v-expansion-panel-header {
  border: 1px #eee solid;
}

.theme--dark {
  .v-expansion-panel-header {
    border-color: #292525;
  }
}

@media screen and (max-width: 480px) {
  .stats {
    font-size: 0.7em;
  }
}
</style>